"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.throttle = void 0;
const performance_now_1 = require("./performance.now");
const throttle = (cb, ms) => {
    let blockUntil = -Infinity;
    let eventualTimeout = false;
    const callbackWrapper = () => {
        const now = performance_now_1.performanceNow();
        const delta = blockUntil - now;
        if (blockUntil > now) {
            if (!eventualTimeout) {
                eventualTimeout = setTimeout(callbackWrapper, delta + 1);
            }
            return;
        }
        blockUntil = now + ms;
        cb();
        if (eventualTimeout) {
            clearTimeout(eventualTimeout);
            eventualTimeout = false;
        }
    };
    return callbackWrapper;
};
exports.throttle = throttle;
//# sourceMappingURL=throttle.js.map